(() => {
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  const sourceRoot = document.querySelector('[data-review-form-root]');
  const sourceForm = sourceRoot?.querySelector('#YurchakReviewForm');
  if (!sourceRoot || !sourceForm || window.__yurchakReviewResendBridgeInstalled) return;
  window.__yurchakReviewResendBridgeInstalled = true;

  const endpoint = 'https://qzrzxngxwiudcvtksvuj.supabase.co/functions/v1/yurchak-review-email';
  const startedAt = Date.now();
  const nativeSubmit = HTMLFormElement.prototype.submit;

  let honeypot = sourceForm.querySelector('[data-review-website]');
  if (!honeypot) {
    honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = 'website';
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    honeypot.setAttribute('aria-hidden', 'true');
    honeypot.setAttribute('data-review-website', '');
    honeypot.style.cssText = 'position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;';
    sourceForm.appendChild(honeypot);
  }

  const extract = (body, key) => {
    const re = new RegExp('\\[\\[' + key + '\\]\\]([\\s\\S]*?)\\[\\[\\/' + key + '\\]\\]', 'i');
    return (body.match(re)?.[1] || '').trim();
  };

  const showSuccess = () => {
    const panel = sourceRoot.querySelector('.ylr__panel');
    if (!panel) return;
    panel.innerHTML = '<div class="ylr__success" role="status" tabindex="-1"><span aria-hidden="true">✓</span><h2>Thank you.</h2><p>Your review has been sent to the YURCHAK team. We’ll review it before publishing.</p></div>';
    panel.querySelector('.ylr__success')?.focus();
  };

  const showError = (message) => {
    const err = sourceForm.querySelector('[data-upload-error]');
    const status = sourceForm.querySelector('[data-review-status]');
    const submit = sourceForm.querySelector('[data-review-submit]');
    if (err) {
      err.textContent = message || 'We could not send your review. Please refresh the page and try again.';
      err.hidden = false;
    }
    if (status) status.textContent = '';
    if (submit) submit.disabled = false;
    sourceForm.dispatchEvent(new CustomEvent('yurchak:review-email-failed',{detail:{message}}));
  };

  const deliver = async () => {
    const body = sourceForm.querySelector('[data-review-body]')?.value || '';
    const name = sourceForm.querySelector('[name="comment[author]"]')?.value?.trim() || '';
    const email = sourceForm.querySelector('[name="comment[email]"]')?.value?.trim() || '';
    const review = sourceForm.querySelector('[data-review-text]')?.value?.trim() || extract(body, 'TEXT');
    const mediaUrl = extract(body, 'MEDIA');
    const permission = sourceForm.querySelector('[data-review-permission]')?.checked ?? (extract(body, 'PERMISSION').toLowerCase() === 'yes');
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        email,
        review,
        mediaUrl,
        permission,
        website: honeypot?.value || '',
        startedAt
      })
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.error || 'We could not send your review. Please refresh the page and try again.');
    showSuccess();
    sourceForm.dispatchEvent(new CustomEvent('yurchak:review-email-sent'));
  };

  HTMLFormElement.prototype.submit = function () {
    if (this === sourceForm) {
      const body = sourceForm.querySelector('[data-review-body]')?.value || '';

      // Shopify can call submit() internally before our async media upload is finished.
      // Ignore those early calls. The final YURCHAK submit always has this marker,
      // which is written only after the upload/build step has completed.
      if (!body.includes('[[YURCHAK_REVIEW_V2]]')) return;

      // Prevent any second programmatic submit from creating a duplicate email.
      if (sourceForm.dataset.reviewEmailSending === '1' || sourceForm.dataset.reviewEmailSent === '1') return;
      sourceForm.dataset.reviewEmailSending = '1';

      deliver()
        .then(() => {
          sourceForm.dataset.reviewEmailSent = '1';
        })
        .catch((error) => {
          console.error('YURCHAK review email failed', error);
          showError(error?.message);
        })
        .finally(() => {
          sourceForm.dataset.reviewEmailSending = '0';
        });
      return;
    }
    return nativeSubmit.call(this);
  };
})();
